// A ROTA CLÁSSICA — a plataforma como ela era.
//
// O pedido do operador, na letra: "as cores da versão clássica têm que ser as mesmas originais,
// tudo de layout mesmo de original".
//
// Isto é mais forte que "parecida": a rota clássica **não segue a escolha de tema**. Se seguisse,
// alguém com o tema Quadrinho escolhido abriria `/classico` e veria o layout antigo pintado com
// as cores novas — o oposto do que esta rota existe para ser.
//
// Foi exatamente o defeito que eu introduzi ao migrar tudo para variável de tema de uma vez: a
// versão clássica deixou de ser a original.
//
// O `data-tema="classico"` aqui é LOCAL: variável CSS herda do ancestral mais próximo, então
// este atributo sobrescreve o do documento apenas dentro desta subárvore. O resto da plataforma
// continua com o tema que o usuário escolheu.
//
// A `landing-page.scss` foi restaurada byte a byte do commit 55808e5 — o último antes deste
// trabalho — inclusive os `100vw`/`100vh` que causam o T1.40. Isso é deliberado: a versão
// clássica é a antiga, com os defeitos dela. As correções vivem na rota nova.
//
// ── A EXCEÇÃO, E ELA TEM LIMITE ESCRITO — `T8.7` ───────────────────────────────────────────
//
// O `classico.scss` abaixo sobrescreve três propriedades daquele contêiner, e só nesta rota. Não é
// recuo da decisão de cima: em 55808e5 esta página tinha o **próprio rodapé dentro** do contêiner
// de `100vh`, e hoje o rodapé é o global, montado depois dela. A combinação nunca existiu no commit
// preservado, e é ela que torna "Quem somos", "Objetivos" e "Parceiros" inalcançáveis.
//
// O limite: o que se sobrescreve é **quem rola**, nunca cor, fonte, espaçamento ou desenho. O
// arquivo diz por quê, linha por linha.

import { useEffect } from "react";
import LandingPage from "../landing-page/landing-page";
import NavClassico from "./nav-classico";
import "./classico.scss";

function Classico() {
  useEffect(() => {
    document.title = "HQ-Lab — versão clássica";
    return () => {
      document.title = "HQ-Lab";
    };
  }, []);

  return (
    <div data-tema="classico">
      <LandingPage nav={<NavClassico />} />
    </div>
  );
}

export default Classico;
